import { ExternalLink } from 'lucide-react';
import { getWorkCardUrl, OTHER_JOB } from '@/constants/divisions';

// Shows "Job: <name>" with a link to the division's work card PDF (opens in a new tab).
const JobWorkCard = ({ task, className = '' }) => {
  if (!task || !task.job) return null;
  const url = task.job === OTHER_JOB ? null : getWorkCardUrl(task.deliverable);
  return (
    <p className={`text-sm text-slate-600 ${className}`} data-testid="job-work-card">
      <span className="font-medium">Job:</span> {task.job}
      {url && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="ml-2 inline-flex items-center gap-1 text-blue-700 hover:underline"
          data-testid="work-card-link"
        >
          Work card <ExternalLink className="h-3 w-3" />
        </a>
      )}
    </p>
  );
};

export default JobWorkCard;
